import React, { Component } from 'react';
import Header from '../../Common/Headers/Header';
import { StyleRules, withStyles } from '@material-ui/core/styles';
import StatusBar from '../../Common/Headers/StatusBar';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';

import hub from '../../Common/images/Hub_LED.png';
import header_theme from '../../Common/Themes/header_theme';
import axios, { CancelToken, CancelTokenSource } from 'axios';

import '../../Common/stylesheets/global.scss';
import LinearDeterminate from '../../Common/Loading/Linear';
import { createStyles, Theme } from '@material-ui/core';
import { match } from 'react-router';
import { Unit, User } from '../../Common/Types/cloudApi';
import { hubRebootDateStorage } from '../../Common/utils/storageInterface';
import * as H from 'history';

const styles: StyleRules = createStyles((theme: Theme) => ({
  button: {
    margin: theme.spacing(1),
    marginTop: '24px',
    float: 'right'
  },
  first_line: {
    padding: '24px 24px 12px 24px',
    color: 'rgba(0, 0, 0, 1)',
    fontSize: '24px'
  },
  bold_line: {
    paddingLeft: '24px',
    paddingRight: '24px',
    color: 'rgba(0, 0, 0, 1)',
    fontSize: '24px',
    fontWeight: 800
  },
  middle_line: {
    paddingLeft: '24px',
    paddingRight: '24px',
    color: 'rgba(0, 0, 0, 1)',
    fontSize: '24px'
  },
  padding_middle: {
    padding: '24px 24px 12px 24px'
  }
}));

type Params = {
  communityId: string;
  unitId: string;
};

type Props = {
  completed: number;
  apiRebootCompleted: boolean;
  user: User;
  unit: Unit;
  history: H.History<H.LocationState>;
  match: match<Params>;
};

type State = {
  completed: Props['completed'];
  timer: NodeJS.Timeout | null;
  alertdialog?: boolean;
};

class HubRebooting extends Component<Props, State> {
  __source: CancelTokenSource;
  __cancel: { cancelToken: CancelToken };
  classes: any;

  constructor(props) {
    super(props);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    const cancel = {
      cancelToken: source.token
    };
    this.__source = source;
    this.__cancel = cancel;
    this.openAlert = this.openAlert.bind(this);
    this.returnToUnits = this.returnToUnits.bind(this);
    const { classes } = props;
    this.classes = classes;
    this.state = {
      completed: this.props.completed ? this.props.completed : 0,
      timer: null
    };
  }

  componentDidMount() {
    this.setState({
      timer: setInterval(() => {
        this.setCompleted(this.state.completed);
      }, 2400)
    });
  }

  componentWillUnmount() {
    if (this.state.timer) {
      clearInterval(this.state.timer);
    }
  }

  setCompleted = (oldCompleted) => {
    if (oldCompleted === 100) {
      if (this.state.timer) {
        clearInterval(this.state.timer);
      }
      if (this.props.unit.hub_serial) {
        hubRebootDateStorage(this.props.unit.hub_serial).remove();
      }
      window.location.reload();
    } else if (this.props.apiRebootCompleted) {
      this.setState({
        completed: 100
      });
    } else {
      const diff = 1;
      this.setState({
        completed: Math.min(oldCompleted + diff, 100)
      });
    }
  };

  openAlert(e) {
    e.preventDefault();
    this.setState({
      alertdialog: true
    });
  }

  returnToUnits() {
    const communityId = this.props.match.params.communityId;
    this.props.history.push('/community/' + communityId);
  }

  render() {
    return (
      <div className="full-height">
        <MuiThemeProvider theme={header_theme}>
          <Header
            headerText="Reboot Hub"
            back={true}
            return={this.returnToUnits}
            arrow={true}
            user={this.props.user}
            history={this.props.history}
            subheaderText={this.props.unit.communityName}
            subheaderText2={this.props.unit.unit}
          />
          <StatusBar message="Hub rebooting..." />
          <div>
            <p className={this.classes.first_line}>This may take up to four minutes.</p>
            <p className={this.classes.bold_line}>DO NOT UNPLUG THE HUB!</p>
            <p className={this.classes.middle_line}>
              Reboot progress: <strong>{this.state.completed.toFixed(0)}%</strong>
            </p>
            <div className={this.classes.padding_middle}>
              <LinearDeterminate completed={this.state.completed} />
            </div>
            <p className={this.classes.middle_line}>
              Wait for the LEDs on the hub to turn off. Then, when the hub has finished
              rebooting the first LED on the hub will turn green.
            </p>
            <div style={{ textAlign: 'center', padding: '24px 24px 0px 24px' }}>
              <img src={hub} alt="successful update" style={{ width: '100%' }} />
            </div>
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default withStyles(styles)(HubRebooting);
